import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Page_Header from "../../../General/Page_Header";
import Table2 from "../../../Table2/Table2";
import External_In_Map from "../../../External_Visites/External_In_Map";
import { CheckFont } from "../../../General/GeneralComponent/CheckLang";
import det from "../../../../images/information1.png";
import calendar from "../../../../images/icons/date_icon.svg";

function OtherTaskDetails() {
  const location = useLocation();
  const [lat, setlat] = useState(false);
  const [lng, setlng] = useState(false);
  const [openMap, setOpenMap] = useState(false);
  const { t } = useTranslation();
  const langmiamed = localStorage.getItem("langmiamed");
  const taskVisites = location?.state?.taskDetails || {};
  const taskVisitesArray = [taskVisites];
  const storeMap = (lat, lng) => {
    setlat(lat);
    setlng(lng);
    setOpenMap(true);
  };
  const columns1 = [
    {
      name: <span className="color_spann">{t("address")}</span>,
      sortable: true,
      cell: (row) => <span>{row?.external_visit?.address || t("N/A")}</span>,
    },
    {
      name: <span className="color_spann">{t("report_type_name")}</span>,
      sortable: true,
      cell: (row) => <span>{row?.external_visit?.report_type_name || t("N/A")}</span>,
    },
    {
      name: <span className="color_spann">{t("description")}</span>,
      sortable: true,
      cell: (row) => <span>{row?.external_visit?.description || t("N/A")}</span>,
    },
    {
      name: <span className="color_spann">{t("map")}</span>,
      cell: (row) => (
        <i
          className="las la-map-marked icon_edit_table"
          onClick={() => storeMap(row.lat, row.lng)}
        ></i>
      ),
    },
  ];

  return (
    <div className={langmiamed === "ar" ? "main-content_ar" : "main-content_en"}>
      <main>
        <Page_Header
          langmiamed={langmiamed}
          header={t("taskDetails")}
          path={`${t("home")} / ${t("taskDetails")}`}
        />
      </main>
      <div className="page-content">
      <div
                className="div_task_details"
                dir={langmiamed == "ar" ? "rtl" : "ltr"}
              >
                <img src={det} />
                <div className="div_task_details_info">
                  {taskVisites.status == "is_done" ? (
                    <div className="row_div_task_details">
                      <i
                        className={`fas fa-check-circle ${
                          langmiamed == "ar"
                            ? "margin_left_20"
                            : "margin_right_20"
                        }`}
                        style={{ color: "#56ADE1", marginTop: "-10px" }}
                      ></i>
                      <h5>
                        {t("This_task")} {t("is_done")} (
                        {t(taskVisites.priority_level)})
                      </h5>
                    </div>
                  ) : (
                    <div className="row_div_task_details">
                      <i
                        className={`fas fa-times-circle ${
                          langmiamed == "ar"
                            ? "margin_left_20"
                            : "margin_right_20"
                        }`}
                        style={{ color: "red" }}
                      ></i>
                      <h5>
                        {t("This_task")} {t("is_not_done")} (
                        {t(taskVisites.priority_level)})
                      </h5>
                    </div>
                  )}
                  <div className="row_div_task_details">
                    <img
                      src={calendar}
                      className={
                        langmiamed == "ar"
                          ? "margin_left_20"
                          : "margin_right_20"
                      }
                    />
                    <span style={{ fontFamily: CheckFont(taskVisites.date) }}>
                      {taskVisites.date} / {taskVisites.time}
                    </span>
                  </div>
                  <div className="row_div_task_details">
                    <i
                      class={`las la-comment ${
                        langmiamed == "ar"
                          ? "margin_left_20"
                          : "margin_right_20"
                      }`}
                      style={{ color: "#49B69C" }}
                    ></i>
                    <span style={{ fontFamily: CheckFont(taskVisites.note) }}>
                      {taskVisites.note}{" "}
                    </span>
                  </div>
                  <div className="row_div_task_details">
                    <i
                      className={`fas fa-user-circle ${
                        langmiamed == "ar"
                          ? "margin_left_20"
                          : "margin_right_20"
                      }`}
                      style={{ color: "#EA4D68" }}
                    ></i>
                    <span
                      style={{
                        fontFamily: CheckFont(taskVisites.target_group_name),
                      }}
                    >
                      {taskVisites.target_group_name}
                    </span>
                  </div>
                </div>
              </div>
              <br></br>
        <br />
        <div
          className="newDetails"
          dir={langmiamed === "ar" ? "rtl" : "ltr"}
        >
          {taskVisites.length === 0 ? (
            <div className="no-data-message">{t("No data available")}</div>
          ) : (
            <Table2 col={columns1} roo={taskVisitesArray} />
          )}
        </div>
      </div>
      {openMap && (
        <External_In_Map
          open={openMap}
          setOpen={setOpenMap}
          lat={lat}
          lng={lng}
        />
      )}
    </div>
  );
}

export default OtherTaskDetails;
